import type { SubtitleProvider } from '../../ports/SubtitleProvider.ts';
import { FileUploadSubtitleProvider } from './FileUploadSubtitleProvider.ts';
import { MockSubtitleProvider, type MockSubtitleProviderOptions } from './MockSubtitleProvider.ts';
import {
  SoraSubtitleProvider,
  type SoraSubtitleProviderOptions,
} from './SoraSubtitleProvider.ts';

export type SubtitleProviderKind = 'sora' | 'mock' | 'upload';

export type CreateSubtitleProviderOptions = MockSubtitleProviderOptions &
  SoraSubtitleProviderOptions;

export function createSubtitleProvider(
  kind: SubtitleProviderKind,
  options?: CreateSubtitleProviderOptions,
): SubtitleProvider {
  switch (kind) {
    case 'sora':
      return new SoraSubtitleProvider(options);
    case 'mock':
      return new MockSubtitleProvider(options);
    case 'upload':
      return new FileUploadSubtitleProvider();
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}

export {
  FileUploadSubtitleProvider,
  MockSubtitleProvider,
  SoraSubtitleProvider,
};
